angular.module('impactx.bank').controller('BankListCtrl', [
    'selectedListItems',
    BankListCtrl
]);

function BankListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditBank'
        },
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/bank/templates/banklist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/bank/list',
        id: "banklist",
        mainAction: {id: "new", link: "#/bank", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "bank/" + selectedListItems.getFirstSelectedId();
    }
}
